module.exports = __webpack_public_path__ + "43c3f4a48e8b6a6e64c9200dc7bc4441.jpg";